import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfModal from '@elem/ui/ef-modal';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import EfTitle from '@elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Compare from './Compare';
import { imgLocaleA, imgLocaleB, imgLocaleC } from './Imgs';
import styles from './index.module.scss';
import More from './More';
import EcoSpace from 'eco-design/base/eco-space';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const [showModal, setShowModal] = useState(false);
    const [gap, setGap] = useState(24);
    const [isClient, setIsClient] = useState(false);
    const [active, setActive] = useState(0);
    const [showCompare, setShowCompare] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const { locale = 'us' } = useRouter();
    const IS_NA = ['us', 'ca', 'br', 'mx'].includes(locale);
    const openMore = () => {
        setShowMore(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_more',
            list_name: t('title'),
            button_name: t('more_btn'),
        });
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const imgC = imgLocaleC[locale] || imgLocaleC['eu'];
    const configs = {
        theme: 'white',
        loop: true,
        navigation: false,
        pagination: false,
        lists: [
            {
                tab: t('a_tab'),
                desc: t('a_desc'),
                isVideo: IS_NA,
                pc: imgA.pc,
                h5: imgA.h5,
                customizedEl: IS_NA && (
                    <span className="learn" onClick={openMore}>
                        {t('more_btn')}
                    </span>
                ),
                moreText: IS_NA ? t('more_btn') : '',
            },
            {
                tab: t('b_tab'),
                desc: t('b_desc'),
                customizedEl: !IS_NA && (
                    <span className="learn" onClick={openMore}>
                        {t('more_btn')}
                    </span>
                ),
                pc: imgB.pc,
                h5: imgB.h5,
                moreText: !IS_NA ? t('more_btn') : '',
            },
            {
                tab: t('c_tab'),
                desc: t('c_desc'),
                pc: imgC.pc,
                h5: imgC.h5,
            },
        ],
        callback: (index) => setActive(index),
    };

    const icon = (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="36" height="36" rx="18" fill="url(#paint0_linear_1272_65170)" />
            <path d="M25.2833 18.5001H10.7167" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 11.2168V25.7834" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_1272_65170" x1="5.07599e-06" y1="5.30002" x2="26.6868" y2="-1.27879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3F68E0" />
                    <stop offset="1" stopColor="#7D9DFC" />
                </linearGradient>
            </defs>
        </svg>
    );

    const openCompare = () => {
        setShowCompare(true);
        const item = configs?.lists[active];
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: item.tab,
            button_name: t('a_btn'),
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 16 : 0);
            setIsClient(true);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            <EfSwiperTab {...configs} gap={gap} />
            {locale !== 'kr' && (
                <button className="btn" onClick={openCompare}>
                    <span className="text">{t('a_btn')}</span>
                    {icon}
                </button>
            )}
            {locale === 'kr' && (
                <>
                    <EcoSpace />
                    <div className="compare-wrapper">
                        <Compare />
                    </div>
                </>
            )}
            {showCompare && (
                <EfModal position="center" open={showCompare} className="compare-modal" callback={() => setShowCompare(false)}>
                    <Compare />
                </EfModal>
            )}
            {showMore && (
                <EfModal position="center" open={showMore} className="more-modal" callback={() => setShowMore(false)}>
                    <More />
                </EfModal>
            )}
        </div>
    );
}
